import * as Dialog from '@radix-ui/react-dialog';
import styled, { css } from 'styled-components';

import {
  white,
  gray,
  grayLight,
  grayDefault,
  grayDarker,
} from '@bufferapp/ui/style/colors';
import UnknownIcon from '@bufferapp/ui/Icon/Icons/Unknown';

export const StyledOverlay = styled(Dialog.Overlay)`
  position: fixed;
  width: 100%;
  height: 100%;
  background-color: rgb(50, 59, 67, 0.8);
  opacity: 0.9;
  z-index: 4;
`;

export const ModalWrapper = styled(Dialog.Content)`
  position: fixed;
  display: flex;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 4;
  width: 854px;
  height: 590px;
  background-color: ${gray};
  border-radius: 4px;
`;

export const InnerWrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  flex-direction: column;
`;

export const Description = styled.div`
  display: flex;
  background-color: ${white};
  padding: 32px 40px;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
`;

export const DescriptionLabel = styled.div`
  display: flex;
`;

export const DescriptionInput = styled.div`
  display: flex;
  flex-direction: column;
  margin-right: 10px;
  flex-grow: 1;
`;

export const MediaContainer = styled.div`
  display: flex;
  flex-grow: 1;
  align-items: center;
  justify-content: center;
  max-height: 100%;
  max-width: 100%;
  overflow: hidden;
`;

export const ButtonWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-self: flex-end;
  align-items: center;
`;

export const CountWrapper = styled.div`
  margin-bottom: 8px;
  display: flex;
  align-self: flex-end;
  align-items: center;
  height: 35px;
  margin-right: 14px;
`;

export const CountBox = styled.div`
  background-color: ${grayLight};
  color: ${grayDefault};
  border-radius: 4px;
  padding: 4px;
  height: 16px;
  width: 28px;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const UnknownIconStyled = styled(UnknownIcon)`
  border: 1px solid ${gray};
  border-radius: 50%;
  padding: 1px;
  background-color: ${gray};
  margin-left: 3px;
  color: ${white};
  margin-top: -2px;
  display: block;
  cursor: pointer;
`;

export const FileSize = styled.div`
  position: absolute;
  left: 10px;
  bottom: 10px;
  background: ${grayDarker};
  opacity: 0.8;
  color: ${white};
  border-radius: 3px;
  font-size: 12px;
  padding: 3px;
  font-weight: bold;
`;

export const Media = css`
  max-height: 100%;
  max-width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const Image = styled.img`
  ${Media}
`;

export const Video = styled.video`
  ${Media}
`;
